import { getComponentsByPrototype } from '../stores/componentManager';

export default class FormRestaurant extends HTMLElement {
    // Base URL for restaurant booking API
    static BASE_URL = 'https://www.sevenrooms.com/reservations';

    constructor(m) {
        super(m);

        // Binding event handlers to the class instance
        this.onFormSubmit = this.onFormSubmit.bind(this);

        // Select key UI elements
        this.$form = this.querySelector('[data-form]');
        this.$formInner = this.querySelector('[data-form-inner]');
    }

    // =============================================================================
    // Lifecycle methods
    // =============================================================================
    connectedCallback() {
        // Bind event listeners
        this.bindEvents();
    }

    disconnectedCallback() {
        // Unbind event listeners when the component is disconnected
        this.unbindEvents();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        // Bind form submission event
        this.$form.addEventListener('submit', this.onFormSubmit);
    }

    unbindEvents() {
        // Remove previously bound eventlistener
        this.$form.removeEventListener('submit', this.onFormSubmit);
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onFormSubmit(e) {
        e.preventDefault();

        // Collect form data
        const data = new FormData(this.$form);

        // Construct and open the booking URL
        this.buildUrl(data);
    }

    // =============================================================================
    // Methods
    // =============================================================================
    buildUrl(data) {
        // Construct the booking URL with base URL and form data
        const url = new URL(`${FormRestaurant.BASE_URL}/${data.get('restaurant-property')}`);

        // Open the URL in a new browser tab
        window.open(url.toString(), '_blank');

        // Reset the form and close modal
        this.resetForm();
        getComponentsByPrototype('Modal')
            .filter(($modal) => $modal.dataset.modalName === 'booking')
            .forEach(($modal) => {
                $modal.close();
            });
    }

    resetForm() {
        // Reset form fields
        this.$form.reset();
    }
}
